import angular from 'angular';
import doctorSearchComponent from './doctor-search.component';

const doctorSearch = angular
	.module('doctorSearch', [])
	.component('doctorSearch', doctorSearchComponent)
	.name;

export default doctorSearch;



// WEBPACK FOOTER //
// ./~/@front10/healthcare-book/src/app/components/doctor-search/doctor-search.module.js